import { format } from 'date-fns';
import React from 'react';
import { Button, Input } from 'reactstrap';
import { Link } from 'react-router-dom';
import EditIcon from '../../Res/Icon/numberEdit.svg';
import ViewIcon from '../../Res/Icon/view.png';
import LogImg from '../../Res/Icon/numberLog.svg';
import DeleteIcon from '../../Res/Icon/numberDelete.svg';
import NumberRoute from './NumberRoute';
import utils from '../../lib/utils';
import { getPermissionForComponent } from '../../utils/permissionsUtils';
import TooltipCustom from '../EpikBoxes/EpikBoxDetails/TooltipCustom';

const AllNumber = ({ number, onEdit, user, selectRoute, gateways, onDelete, onShowLog, onCheckboxChange, isChecked, selectedBulkAction }) => {
  const { type, company, _id, routeInfo } = number;
  const numberBulkActionsAccess = getPermissionForComponent('numberBulkActionsAccess',user.permissionsGroup);
  const changeNumberRoute = (e) => {
    let obj = {}
    if (number.carrier == 'inteliquent') {
      obj.trunk = e.currentTarget.value
    }
    if (number.carrier == 'voicetel') {
      obj.routeInfo = {
        route: JSON.parse(e.currentTarget.value).route,
        gateway: JSON.parse(e.currentTarget.value).gateway,
      }
    }
    if (number.carrier == 'tdm') {
      obj.tdmRoute = e.currentTarget.value
    }
    selectRoute(_id, obj);
  }
  return (
    <tr key={number?._id}>
       <td style={{ display: 'flex', alignItems: 'center' }}>
        { (numberBulkActionsAccess === 'write' || numberBulkActionsAccess === 'both') && 
          <Input
            type="checkbox"
            name="isChecked"
            onChange={(e) => onCheckboxChange(_id, e.target.checked)}
            checked={isChecked}
            style={{ margin: 0, position: 'relative', marginRight: '10px' }}
            disabled={(selectedBulkAction === 'unassign') && (type === 'oob' || type === 'callIdMask' || type === 'tollFree')}
            id={`tooltip-unassign-${number?._id}`}

          />
        }
        {
          (selectedBulkAction === 'unassign') && (type === 'oob' || type === 'callIdMask' || type === 'tollFree') && 
          <TooltipCustom
            tipId={`tooltip-unassign-${number?._id}`}
            displayData="You can't unassign this number"
            placement="top"
          />
        }
        <span id={`tooltip-${number?._id}`}>{number?.number}</span>
        {
          number?.isNumberLocked && 
          <TooltipCustom
            tipId={`tooltip-${number?._id}`}
            displayData="Number Lock is Enabled"
            placement="top"
          />
        }
      </td>
      <td>
        {number?.linkedBox?._id ? (
          <Link
            className="box-name-link"
            to={`/boxes/${number?.linkedBox?._id}?company=${number?.linkedBox?.assignedTo}`}
          >
            {number?.linkedBox?.displayName}
          </Link>
        ) : (
          '-'
        )}
      </td>
      <td>{number.temporary}</td>
      <td>{company && company.name}</td>
      {
        utils.filterCustomer(user?.role) ? (
          // <td>{number.carrier === 'voicetel' ? 'VT' : number.carrier === 'tdm' ? "TDM" : 'IQ'}</td>
          //           <td>
          //   {number.carrier === 'voicetel' 
          //     ? 'VT' 
          //     : number.carrier === 'tdm' 
          //     ? 'TDM' 
          //     : number.carrier === 'verizontdm' 
          //     ? 'VZ TDM' 
          //     : number.carrier === 'verizonsip' 
          //     ? 'VZ SIP' 
          //     : number.carrier === 'telnyx' 
          //     ? 'TLNX' 
          //     : number.carrier === 'iqtollfree' 
          //     ? 'IQ TF' 
          //     : number.carrier === 'inteliquent' 
          //     ? 'IQ'
          //     : 'IQ'}
          // </td>
          <td>
            {
              {
                nonepikline: 'NEL',
                voicetel: 'VT',
                tdm: 'TDM',
                verizontdm: 'VZ TDM',
                verizonsip: 'VZ SIP',
                telnyx: 'TLNX',
                iqtollfree: 'IQ TF',
                inteliquent: 'IQ',
                skyt: 'SKYT',
              }[number.carrier] || 'IQ'
            }
          </td>

        ) : null
      }

      {/* <td>{type}</td> */}
        {type === 'sip'
          ? 'CAS' : type}

      {user.role === 'superAdmin' ||
        user.role === 'companyGroupAdmin' ||
        user.role === 'supportEngineer' ? (
        <td style={{ width: '20%' }}>
          <NumberRoute
            onChange={changeNumberRoute}
            number={number}
          />
        </td>
      ) : null}
      <td>
        {(number.dateCreated && utils.getDateTimeFormat(number.dateCreated, 'regular')) || ''}
      </td>
      {

        utils.filterCustomer(user?.role) ? (

          user.role === 'superAdmin' ||
            user.role === 'companyGroupAdmin' ||
            user.role === 'supportEngineer' ? (
            <>
              <td>
                <Button
                  style={{ background: 'inherit', border: 'none' }}
                  onClick={() => {
                    onShowLog(number._id)
                  }}
                >
                  <img style={{ height: '22px' }} src={LogImg} alt="showLog" />
                </Button>
              </td>
              <td>
                <Button
                  style={{ background: 'inherit', border: 'none' }}
                  onClick={() => {
                    onEdit({
                      ...number,
                    });
                  }}
                  id="edit-btn"
                >
                  <img style={{ height: '22px' }} src={EditIcon} alt="edit" />
                </Button>
              </td>
              {number.linkedBox ? <td></td> : (
                <td>
                  <Button
                    style={{ background: 'inherit', border: 'none' }}
                    onClick={() => {
                      onDelete({
                        ...number,
                      });
                    }}
                    disabled={number?.isNumberLocked}
                  >
                    <img style={{ height: '22px' }} src={DeleteIcon} alt="delete" />
                  </Button>
                </td>
              )}
            </>
          ) : (
            <td>
              <Button
                style={{ background: 'inherit', border: 'none' }}
                onClick={() => {
                  onEdit({
                    ...number,
                  });
                }}
              >
                <img style={{ height: '22px' }} src={ViewIcon} alt="view" />
              </Button>
            </td>
          )) : null}
    </tr>
  );
};

export default AllNumber;
